module.exports = __webpack_public_path__ + "fonts/80be1a7.woff2";